import {Col, Flex, Row, Space} from "antd";
import React, {useEffect} from "react";
import {Animation} from "../../feature/project/Shot";
import {useAppDispatch, useAppSelector} from "../../feature/tools";
import {useParams} from "react-router-dom";
import {fetchAnimations} from "../../feature/project/animationsSlice";
import {AnimationItem} from "./Animation";

export enum AnimationType {
    TransitionIn = 'TransitionIn',
    TransitionOut = 'TransitionOut',
    Animation = 'Animation'
}

export const Animations = (props: { onSelect: (animation: Animation, type: AnimationType) => void, type: AnimationType }) => {
    const dispatch = useAppDispatch()
    const {projectId} = useParams()
    const animations = useAppSelector(state => state.animations.animations)

    useEffect(() => {
        if (projectId) {
            dispatch(fetchAnimations({projectId: parseInt(projectId), animationType: props.type}))
        }
    }, [projectId, props.type, dispatch])

    return (
        <Flex gap={16}>
            <Space direction={'vertical'} style={{width: '100%', maxHeight: 800, overflowY: 'auto', scrollbarWidth: "none"}} size={16}>
                <Row>
                    {animations?.map((animation, index) =>
                        <Col span={8}
                             onClick={() => props.onSelect(animation, props.type)}
                             key={animation.id}
                        >
                            <div style={{
                                marginTop: 8,
                                marginBottom: 8,
                                marginLeft: index % 3 == 0 ? 0 : 8,
                                marginRight: (index+1) % 3 == 0 ? 0 : 8,
                                height: 200,
                                overflow: 'hidden',
                                position: 'relative',
                                borderRadius: 6,
                                overflowClipBox: 'content-box'
                            }}>
                                <AnimationItem animation={animation}/>
                            </div>
                        </Col>
                    )}
                </Row>
            </Space>
        </Flex>
    );
}